<template>
  <div class="from-dialog">
    <!-- 体验表单 -->
    <div class="form-box">
      <div class="form">
        <img src="../../assets/img/formImg/close.png" class="close" @click="closeDialog">
        <div v-if="!isSubmit" class="form-con-box">
          <div class="form-title">立即体验</div>
          <div class="form-con">
            <el-form label-position="top" :model="formData" :rules="formRules" ref="form">
              <el-form-item prop="interestProduct">
                <template slot="label">您感兴趣的产品<span class="star">*</span></template>
                <el-input v-model="formData.interestProduct" placeholder="请输入您感兴趣的产品"></el-input>
              </el-form-item>
              <el-form-item prop="companyname">
                <template slot="label">单位名称<span class="star">*</span></template>
                <el-autocomplete
                  v-model="formData.companyname"
                  placeholder="请输入您的单位名称"
                  :fetch-suggestions="querySearch"
                  :trigger-on-focus="false"
                  value-key="name"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item prop="phone">
                <template slot="label">联系方式<span class="star">*</span></template>
                <el-input v-model="formData.phone" placeholder="请输入您的联系方式"></el-input>
              </el-form-item>
              <!-- 暂时隐藏验证码 -->
                        <!-- <el-form-item>
                            <template slot="label">验证码<span class="star">*</span></template>
                            <el-input v-model="formData.checkCode" placeholder="请输入验证码"></el-input>
                            <span class="code" @click="sendCode" :class="{'isDisabled': isSend}">发送验证码</span>
                        </el-form-item> -->
            </el-form>
          </div>
          <el-button class="form-btn" @click="submit">开始体验</el-button>
        </div>
        <div v-else class="submit-success">
          <img src="../../assets/img/formImg/submit-success.png">
          <div class="success-title">提交成功</div>
          <div class="success-tip">我们会在3个工作日内与您联系，请注意接听来电</div>
          <el-button class="success-btn" @click="closeDialog">好的</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { sendCode, submitForm, queryCompanyName } from '../../api/form';

  export default {
    name: 'InterestForm',
    props:{
      productName:{
        type: String,
        default: ''
      }
    },
    data() {
      return {
        formData: {
          companyname: '', // 企业名称
          username: '',
          phone: '',
          checkCode: '', // 验证码
          sourceway: '', // 访问途径
          registerProduct: '轻骑兵', // 注册信息的产品
          interestProduct: '', // 感兴趣产品
          concreteDemand: '', // 具体需求
          formResource:'产品咨询表单',
        },
        formRules: {
          interestProduct: [{ required: true, message: ' ', trigger: 'blur' },],
          companyname: [{ required: true, message: ' ', trigger: 'blur' },],
          phone: [{ required: true, message: ' ', trigger: 'blur' },],
          // checkCode: [{ required: true, message: ' ', trigger: 'blur' },],
        },
        isSubmit: false,
        companies: [],
        isSend: false,
      };
    },
    methods: {
      // 查询单位名称
      async querySearch(queryString, cb) {
        const self = this;
        let resList = [];
        await queryCompanyName({word: queryString}).then((res) => {
          if ((res.status === '200' || res.status === 200)) {
            if(res.data.result !=null){
              resList = res.data.result.items || [];
              cb(resList);
            }
          } else {
            self.$message.error(res.data);
          }
        }).catch((error) => {
        });
        console.log(resList);
      },
      // 校验手机号
      checkPhone() {
        const self = this;
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(self.formData.phone)) {
          self.$message.error('请输入正确的联系方式!');
          return false;
        }
        return true;
      },
      // 发送验证码
      sendCode() {
        const self = this;
        if (!self.checkPhone()) {
          return;
        }
        self.isSend = true;
        if (!self.checkPhone()) {
          self.isSend = false;
          return;
        }
        sendCode(self.formData.phone).then((res) => {
          if ((res.data.code === '200' || res.data.code === 200) && res.data.msg === '发送成功') {
            self.$message.success('验证码发送成功!');
          } else {
            self.$message.error(res.data);
          }
          self.isSend = false;
        }).catch((error) => {
          self.$message.error('验证码发送失败!');
          self.isSend = false;
        });
      },
      // 提交表单
      submit() {
        const self = this;
        let error = false;
        self.$refs.form.validate((valid) => {
          error = !valid;
        });
        if (error) {
          return;
        }
        const param = self.formData;
        submitForm(param).then((res) => {
          if ((res.status === '200' || res.status === 200) && res.data === '注册成功') {
            self.$message.success('提交成功!');
            self.isSubmit = true;
          } else {
            self.$message.error(res.data);
          }
        }).catch((error) => {
          self.$message.error('提交失败!');
        });
      },
      // 关闭弹窗
      closeDialog() {
        const self = this;
        self.$emit('closeInterestFrom');
      },
    },
    mounted() {
      this.formData.interestProduct = this.productName
    },
  }
</script>
<style scoped>
  .from-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }
  .form-box {
    position: fixed;
    top: 50%;
    left: 50%;
    display: flex;
    width: 493px;
    height: 582px;
    background: url('../../assets/img/MallPage/form-bg.png');
    transform: translate(-50%, -50%);
    border-radius: 8px;
    z-index: 2000;
  }

  .form {
    position: relative;
    width: 493px;
  }
  .form-con-box {
    padding: 51px 81px 0;
  }
  .form img.close {
    position: absolute;
    top: 18px;
    right: 21px;
    cursor: pointer;
  }
  .form-con-box .form-title {
    margin-bottom: 24px;
    font-size: 24px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #018DFF;
    line-height: 33px;
    text-align: center;
  }
  .form-con >>> .el-form-item {
    position: relative;
    margin-bottom: 0;
  }
  .form-con >>> .el-form-item .el-form-item__label {
    padding: 0;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #60646B;
    line-height: 22px;
  }
  .star {
    color: #FF5804;
  }
  .form-con >>> .el-form-item .el-input__inner {
    width: 100%;
    height: 46px;
    margin-top: 5px;
    margin-bottom: 12px;
    padding-left: 10px;
    border: 1px solid #D3D6DB;
    border-radius: 4px;
    line-height: 46px;
  }
  .form-con >>> .el-form-item.is-error .el-input__inner {border: 1px solid #F56C6C;}
  .form-con >>> .el-form-item .el-form-item__content > div {
    width: 100%;
  }
  .form-con span.code {
    position: absolute;
    top: 17px;
    right: 12px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #186CF5;
    line-height: 20px;
    cursor: pointer;
  }
  .form-con-box .form-btn {
    width: 100%;
    height: 46px;
    margin-top: 20px;
    background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);
    border: none;
    color: #FFF;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
  }
  .form-con-box .form-btn:hover {
    background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);
  }
  .form-con >>>  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {display: none;}

  /* 提交成功 */
  .submit-success {
    padding-top: 162px;
    text-align: center;
  }
  .submit-success img {
    margin-bottom: 30px;
  }
  .submit-success .success-title {
    margin-bottom: 7px;
    font-size: 24px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #202124;
    line-height: 33px;
  }
  .submit-success .success-tip {
    margin-bottom: 80px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #202124;
    line-height: 22px;
  }
  .submit-success .success-btn {
    width: 110px;
    height: 46px;
    background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);
    border: none;
    border-radius: 4px;
    color: #FFF;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
  }
  .submit-success .success-btn:hover {
    background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);
  }
  .isDisabled {
    pointer-events: none;
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/components/include/InterestForm.vue